export default __webpack_public_path__ + "static/media/logoAmericanExpress.3e4668c9.svg";